import {
    mediaPartnerApplicationList,
    mediaPartnerApplicationByID,
} from '@/services/agency/showcaseMediaPartnerApplications.service'

export default {
    namespaced: true,
    state: {
        mediaPartnerApplicationList: { meta: { pagination: { total: 0 } } },
        mediaPartnerApplication: {},
        mediaPartnerApplicationStatus: 'pending',
    },
    getters: {
        getMediaPartnerApplicationList(state) { return state.mediaPartnerApplicationList },
        getMediaPartnerApplication(state) { return state.mediaPartnerApplication },
        getMediaPartnerApplicationStatus(state) { return state.mediaPartnerApplicationStatus },
    },
    mutations: {
        MEDIA_PARTNER_APPLICATION_LIST(state, value) { state.mediaPartnerApplicationList = value },
        SET_MEDIA_PARTNER_APPLICATION(state, value) { state.mediaPartnerApplication = value },
        MEDIA_PARTNER_APPLICATION_STATUS(state, value) { state.mediaPartnerApplicationStatus = value },
    },
    actions: {
        async fetchMediaPartnerApplicationList({ commit }, params) {
            window.scrollTo({ top: 0, behavior: 'smooth' })
            commit('MEDIA_PARTNER_APPLICATION_STATUS', 'pending')
            commit('MEDIA_PARTNER_APPLICATION_LIST', { meta: { pagination: { total: 0 } } })
            try {
                const { data } = await mediaPartnerApplicationList(params)
                commit('MEDIA_PARTNER_APPLICATION_STATUS', 'init')
                commit('MEDIA_PARTNER_APPLICATION_LIST', data)
                return data
            } catch (error) {
                commit('MEDIA_PARTNER_APPLICATION_STATUS', 'init')
                throw error
            }
        },
        async fetchMediaPartnerApplicationByID({ commit }, params) {
            commit('MEDIA_PARTNER_APPLICATION_STATUS', 'pending')
            try {
                const { data } = await mediaPartnerApplicationByID(params)
                commit('MEDIA_PARTNER_APPLICATION_STATUS', 'init')
                commit('SET_MEDIA_PARTNER_APPLICATION', data.data)
                return data
            } catch (error) {
                commit('MEDIA_PARTNER_APPLICATION_STATUS', 'init')
                return error
            }
        },
    },
}
